<!--能人详情-->
<template>
    <div class="bestPerson">
        <div class="breadcrumb w-1400">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/xiangningqing'}">乡宁情</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/talents'}">能人风采</el-breadcrumb-item>
                <el-breadcrumb-item >三农经验详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="p-list w-1400">
            <el-row :gutter="30">
                <el-col :span="18">
                    <div class="b-h2">
                        {{pageData.title}}
                    </div>
                    <div class="row sub-h2">
                        <div>{{pageData.releaseDate}}</div>
                        <div>浏览：142</div>
                        <div>评论：0</div>
                    </div>
                    <div class="b-content" v-html="pageData.content">
                    </div>
                    <div class="pageTo">
                        <p>上一篇：已经是第一篇了</p>
                        <p>下一篇：百名能人回乡 传授养殖及畜牧经验，为振兴家乡尽一份力！</p>
                    </div>
                    <div class="comment">
                        <div class="comment-title">我来说两句</div>
                        <div class="comment-form">
                            <el-input v-model="comment" placeholder="我来说两句" style="width:calc(100% - 120px)"></el-input>
                            <el-button type="warning" > 登录并发布</el-button>
                        </div>
                        
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="p-r">
                        <div class="p-r-title row">
                            <div class="act">最新资讯</div>|
                            <div>热门资讯</div>
                        </div>
                        <div class="hot1 mt-20">
                            <div class="hot1-pic">
                                <el-image style="width:100%;heihgt:100%" fit="cover" :src="require('../../../../public/img/xnq/hot1.png')"></el-image>
                            </div>
                            <div class="hot1-title">西宁最新返乡政策</div>
                        </div>
                        <div class="hotlist clearfix" v-for="item in 5" :key="item + 'hoto'">
                            <div class="hotlist-pic fl">
                                <el-image style="width:100%;heihgt:100%" fit="cover" :src="require('../../../../public/img/xnq/hot2.png')"></el-image>
                            </div>
                            <div class="hot-text fl" >
                                <p>
                                    青稞种植时间与技术经验讲解
                                </p>    
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
            
        </div>
    </div>
</template>
<script>
import thirdNav from '@/components/thirdNav'
import {GetDetail} from '@/api/xiangningqing'
export default {
    components:{
        thirdNav
    },
    data(){
        return{
            comment:'',
            pageData:{},
        }
    },
    methods:{
        getDetail(){
            GetDetail(this.$route.query.id).then(res=>{
                console.log(res.data);
                this.pageData = res.data.data;
            })
        }
    },
    created(){
        this.getDetail();
    }
}
</script>
<style scoped>
.hot-text p{
    display: table-cell;
    vertical-align: middle;
}
.hot-text{
    width: 40%;
    height: 94px;
    padding: 10px;
    display: table;
    color: #666;
    line-height: 18px;
    font-size: 14px;
}
.hotlist-pic{
    width: 60%;
    height: 94px;
    overflow: hidden;
}
.hotlist{
    padding: 15px 0;
    border-bottom: 1px solid #777;
}
.hot1{
    border-bottom: 1px solid #777;
}
.hot1-title{
    text-align: center;
    font-size: 18px;
    padding: 10px 0;
}
.p-r-title div:hover,.p-r-title div.act{
    background: #f89807;
    color: #fff;
}
.p-r-title div{
    padding:0 15px;
    margin: 0 5px;
}
.p-r{
    border: 1px solid #777;
    padding: 15px;
}
.p-r-title{
    font-size: 20px;
    line-height: 40px;
    justify-content: center;
}
.comment-form{
    margin-top: 20px
}
.comment-title{
    font-size: 18px;
    font-weight: 600;
}
.comment{
    margin-top: 20px;
    border-top: 2px solid #f89807;
    padding-top: 10px;
}
.pageTo p:hover{
    color: #0e6ac1;
    text-decoration: underline;
}
.pageTo p{
    padding: 5px 0;
}
.pageTo{
    margin-top: 40px;
    font-size: 16px;
}
.picbox{
    margin: 15px 0;
}
.b-content p{
    text-indent: 30px
}
.b-content{
    padding-top: 20px;
    font-size: 16px;
    line-height: 24px;
}
.sub-h2{
    font-size: 16px;
    color: #999;
    line-height: 30px;
    justify-content: space-between;
    border-bottom: 1px solid #777;
}
.b-h2{
    font-size: 20px;
    font-weight: 600;
    line-height: 40px
}
.bestPerson{
    font-family: '微软雅黑';
}
.breadcrumb >>> .el-breadcrumb .is-link,.breadcrumb >>> .el-breadcrumb .el-breadcrumb__separator,.breadcrumb >>> .el-breadcrumb .el-breadcrumb__inner{
    font-size: 18px;
    font-family: '微软雅黑';
    color: #0e6ac1;
}
.breadcrumb{
    padding: 20px 0 10px 0;
    border-bottom: 1px solid #0e6ac1;
    margin-bottom: 50px;
}
</style>